var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3524 10.4388C23.3519 10.4383 23.3513 10.4377 23.3508 10.4372L13.5607 0.647461C13.1434 0.22998 12.5886 0 11.9984 0C11.4083 0 10.8535 0.229797 10.436 0.647278L0.651026 10.4321C0.64773 10.4354 0.644434 10.4388 0.641138 10.4421C-0.215796 11.304 -0.214331 12.7024 0.645349 13.5621C1.03811 13.955 1.55685 14.1826 2.11147 14.2064C2.134 14.2086 2.1567 14.2097 2.17959 14.2097H2.56979V21.4144C2.56979 22.84 3.72976 24 5.15579 24H8.98599C9.37417 24 9.68911 23.6852 9.68911 23.2969V17.6484C9.68911 16.9979 10.2183 16.4687 10.8689 16.4687H13.128C13.7786 16.4687 14.3078 16.9979 14.3078 17.6484V23.2969C14.3078 23.6852 14.6225 24 15.0109 24H18.8411C20.2671 24 21.4271 22.84 21.4271 21.4144V14.2097H21.7889C22.3789 14.2097 22.9337 13.9799 23.3513 13.5624C24.2119 12.7013 24.2123 11.3005 23.3524 10.4388Z",
    fill: "#FF500F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e19264cd4030ed1e21d6e2f56dfb1c44.svg";
export { ForwardRef as ReactComponent };